import type { SxProps, Theme } from '@portals/core/src/themes/themes';

import { QuestionProps } from './Question';

export const getStyles = (
  theme: Theme,
  { expanded, displayNumbers }: Partial<QuestionProps>
): { [key: string]: SxProps } => {
  return {
    accordion: {},
    summary: {
      '& .MuiAccordionSummary-content': { margin: 0 },
    },
    questionNumber: {
      color: expanded ? theme.palette.secondary.contrastText : theme.palette.secondary.darker,
      backgroundColor: expanded ? theme.palette.grey['A100'] : 'transparent',
      border: '1px solid transparent',
      borderColor: theme.palette.grey['300'],
      borderRadius: '50%',
      display: 'flex',
      width: theme.spacing(8),
      minWidth: theme.spacing(8),
      height: theme.spacing(8),
      justifyContent: 'center',
      alignItems: 'center',
    },
    details: {
      /* Einrückung ausgerichtet an Headline: 36px Iconbreite plus Abstand nach recht 18px = 54px */
      '&.MuiAccordionDetails-root': {
        paddingLeft: !displayNumbers ? 0 : '54px',
      },
    },
  };
};
